import { AbstractSoundController } from "@lib/titan2/dist/game/controller/AbstractSoundController";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { LoaderEvent } from "@lib/titan2/dist/loader/event/LoaderEvent";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { SoundConstants } from "../view/abstract/constant/SoundConstants";
import { ArcadeWheelConstants, ArcadeWheelEvent } from "../view/abstract/display/ArcadeWheel";
import { SlingoEvent } from "./event/SlingoEvent";
/**
 * SoundController.ts
 */
export class SoundController extends AbstractSoundController {
    constructor() {
        super(...arguments);
        this.gameLaunched = false;
        this.loaderClosed = false;
    }
    create() {
        super.create();
        Logger.addObjectRef(this, "SoundController");
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerCore(LoaderEvent.LOADER_REMOVE, this.handleLoaderRemove);
        this.registerGame(CommonGameEvent.START_GAME_REQUEST, this.handlePurchaseEntryRequest);
        this.registerGame(CommonGameEvent.SPIN_REQUEST, this.handleSpinRequest);
        this.registerGame(CommonGameEvent.SPIN, this.handleStandardSpin);
        this.registerGame(CommonGameEvent.FREE_SPIN, this.handleFreeSpin);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN, this.handlePurchaseSpin);
        this.registerGame(CommonGameEvent.STANDARD_SPIN_RECOVERY, this.handleStandardSpinRecovery);
        this.registerGame(CommonGameEvent.FREE_SPIN_RECOVERY, this.handleFreeSpinRecovery);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN_RECOVERY, this.handlePurchaseSpinRecovery);
        this.registerGame(CommonGameEvent.COLLECT_REQUEST, this.handleCollectRequest);
        this.registerGame(SlingoEvent.SPIN_RESULT, this.handleSpinResult);
        this.registerGame(SlingoEvent.REELS_START, this.handleReelsStart);
        this.registerGame(SlingoEvent.REELS_COMPLETE, this.handleReelsComplete);
        this.registerGame(CommonGameEvent.START_GAME, this.handleStartGame);
        this.registerGame(SlingoEvent.REEL_STRIKE, this.handleReelStrike);
        this.registerGame(SlingoEvent.REEL_STRIKE_JOKER, this.handleReelStrikeJoker);
        this.registerGame(SlingoEvent.REEL_STRIKE_SUPER_JOKER, this.handleReelStrikeSuperJoker);
        this.registerGame(SlingoEvent.REEL_STRIKE_FREE_SPIN, this.handleReelStrikeFreeSpin);
        this.registerGame(SlingoEvent.FREE_SPIN_TWEEN, this.handleFreeSpinTween);
        this.registerGame(SlingoEvent.DAB_SUCCESS, this.handleDabSuccess);
        this.registerGame(SlingoEvent.DAB_COMPLETE, this.handleDabComplete);
        this.registerGame(SlingoEvent.SLINGO_1, this.handleSlingoSingle);
        this.registerGame(SlingoEvent.SLINGO_2, this.handleSlingoDouble);
        this.registerGame(SlingoEvent.SLINGO_3, this.handleSlingoTriple);
        this.registerGame(SlingoEvent.SLINGO_4, this.handleSlingoQuadruple);
        this.registerGame(SlingoEvent.GAME_SUMMARY, this.handleGameSummary);
        this.registerCore(SlingoEvent.STAKE_SELECTED_INCREMENT, this.handleStakeSelectedIncrement);
        this.registerCore(SlingoEvent.STAKE_SELECTED_DECREMENT, this.handleStakeSelectedDecrement);
        this.registerCore(SlingoEvent.STAKE_SELECTED_SAME, this.handleStakeSelectedSame);
        this.registerGame(SlingoEvent.FULL_HOUSE_ANIMATION_PHASE_ONE, this.handleFullHouseAnimationPhaseOne);
        //this.registerGame(SlingoEvent.FULL_HOUSE_ANIMATION_PHASE_TWO, this.handleFullHouseAnimationPhaseTwo);
        this.registerGame(SlingoEvent.BIG_WIN_ANIMATION_PHASE_ONE, this.handleBigWinAnimationPhaseOne);
        this.registerGame(SlingoEvent.AVAILABLE_WIN, this.handleAvailableWin);
        this.registerGame(SlingoEvent.SLINGO_PAY_TABLE, this.handleLevelUp);
        this.registerGame(SlingoEvent.SCATTER_WIN_APPEAR, this.handleScatterWinAppear);
        this.registerGame(SlingoEvent.SCATTER_WIN_COUNT, this.handleScatterWinCount);
        this.registerGame(SlingoEvent.SCATTER_WIN_COUNT_END, this.handleScatterWinCountEnd);
        this.registerGame(SlingoEvent.SCATTER_WIN_DISAPPEAR, this.handleScatterWinDisappear);
        this.registerGame(SlingoEvent.FULL_HOUSE_APPEAR, this.handleFullHouseAppear);
        this.registerGame(SlingoEvent.FULL_HOUSE_COUNT, this.handleFullHouseCount);
        this.registerGame(SlingoEvent.FULL_HOUSE_COUNT_END, this.handleFullHouseCountEnd);
        this.registerGame(SlingoEvent.FULL_HOUSE_DISAPPEAR, this.handleFullHouseDisappear);
        this.registerGame(SlingoEvent.BIG_WIN_APPEAR, this.handleBigWinAppear);
        this.registerGame(SlingoEvent.BIG_WIN_COUNT, this.handleBigWinCount);
        this.registerGame(SlingoEvent.BIG_WIN_COUNT_END, this.handleBigWinCountEnd);
        this.registerGame(SlingoEvent.BIG_WIN_DISAPPEAR, this.handleBigWinDisappear);
        this.registerGame(SlingoEvent.SUSPENSE_SPIN, this.handleSuspenseSpin);
        this.registerCore(CommonGameEvent.PLAY_SPINE_SOUND, this.handlePlaySpineSound);
        this.registerGame(ArcadeWheelEvent.WHEEL_SPIN, this.handleArcadeWheelSpin);
        this.registerGame(ArcadeWheelEvent.HIDE, this.handleArcadeWheelHide);
        this.registerGame(ArcadeWheelEvent.SHOW, this.handleArcadeWheelShow);
        this.registerGame(ArcadeWheelEvent.LOSE, this.handleArcadeWheelLose);
        this.registerGame(ArcadeWheelEvent.WIN, this.handleArcadeWheelWin);
    }
    handleScatterWinAppear() {
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_APPEAR"));
    }
    handleScatterWinCount() {
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_COUNT"));
    }
    handleScatterWinCountEnd() {
        this.stopSound(this.getSoundPropertiesFromId("SCATTER_WIN_COUNT"));
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_COUNT_END"));
    }
    handleScatterWinDisappear() {
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_DISAPPEAR"));
    }
    handleFullHouseAppear() {
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_APPEAR"));
    }
    handleFullHouseCount() {
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_COUNT"));
    }
    handleFullHouseCountEnd() {
        this.stopSound(this.getSoundPropertiesFromId("SCATTER_WIN_COUNT"));
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_COUNT_END"));
    }
    handleFullHouseDisappear() {
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_DISAPPEAR"));
    }
    handleBigWinAppear() {
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_APPEAR"));
    }
    handleBigWinCount() {
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_COUNT"));
    }
    handleBigWinCountEnd() {
        this.stopSound(this.getSoundPropertiesFromId("SCATTER_WIN_COUNT"));
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_COUNT_END"));
    }
    handleBigWinDisappear() {
        this.playSound(this.getSoundPropertiesFromId("SCATTER_WIN_DISAPPEAR"));
    }
    handleSuspenseSpin() {
        this.playSound(this.getSoundPropertiesFromId("SUSPENSE_SPIN"));
    }
    handleArcadeWheelSpin() {
        this.playSound(ArcadeWheelConstants.SPIN);
    }
    handleArcadeWheelHide() {
        this.playSound(ArcadeWheelConstants.EXIT);
    }
    handleArcadeWheelShow() {
        this.playSound(ArcadeWheelConstants.ENTRY);
    }
    handleArcadeWheelLose() {
        this.playSound(ArcadeWheelConstants.SPIN_LOSE);
    }
    handleArcadeWheelWin() {
        this.playSound(ArcadeWheelConstants.SPIN_WIN);
    }
    handleLoaderRemove() {
        this.loaderClosed = true;
        if (this.gameInProgress) {
            this.callAfter(2800, this.playBackground);
        }
    }
    playGameReady() {
        this.playSound(this.getSoundPropertiesFromId("GAME_READY"));
    }
    handlePurchaseEntryRequest() {
        this.playBackground();
        this.gameInProgress = true;
    }
    handleSpinRequest() {
        let state = this.model.getState();
        if (this.model.isStakeToSpin()) {
            this.playSound(ArcadeWheelConstants.BUTTON_PRESS);
        }
        else if (state.isPurchaseSpin()) {
            this.playSound(this.getSoundPropertiesFromId("PURCHASE_SPIN_BUTTON"));
        }
        else {
            this.playSound(this.getSoundPropertiesFromId("SPIN_BUTTON"));
        }
    }
    handleCollectRequest() {
        this.playSound(this.getSoundPropertiesFromId("COLLECT_BUTTON"));
        this.gameInProgress = false;
    }
    handleStandardSpin() {
        this.playSound(this.getSoundPropertiesFromId("SPIN_READY"));
    }
    handleFreeSpin() {
        this.playSound(this.getSoundPropertiesFromId("SPIN_READY"));
    }
    handlePurchaseSpin() {
        this.playSound(this.getSoundPropertiesFromId("SPIN_READY_PURCHASE"));
    }
    handleStandardSpinRecovery() {
        this.gameInProgress = true;
    }
    handleFreeSpinRecovery() {
        this.gameInProgress = true;
    }
    handlePurchaseSpinRecovery() {
        this.gameInProgress = true;
    }
    handleSpinResult() {
        let previousState = this.model.getPreviousState();
        if (previousState.isStandardSpin()) {
            this.playReelLoop();
        }
    }
    handleReelsStart() {
        this.playReelLoop();
    }
    playReelLoop() {
        this.stopSound(this.getSoundPropertiesFromId("REEL_LOOP"));
        this.playSound(this.getSoundPropertiesFromId("REEL_LOOP"));
    }
    handleReelsComplete() {
        this.stopSound(this.getSoundPropertiesFromId("REEL_LOOP"));
    }
    handleStartGame() {
        //no-op
    }
    playBackground() {
        let properties = this.getBackground();
        if (properties != this.background) {
            this.stopBackground();
            this.playSound(properties);
            this.background = properties;
        }
    }
    stopBackground() {
        if (this.background) {
            this.stopSound(this.background);
            this.background = null;
        }
    }
    getBackground() {
        return SoundConstants.getBackground(this.model.getCurrentMatchedPatterns());
    }
    handleReelStrikeJoker() {
        this.playSound(this.getSoundPropertiesFromId("REEL_STRIKE_JOKER"));
    }
    handleReelStrikeSuperJoker() {
        this.playSound(this.getSoundPropertiesFromId("REEL_STRIKE_SUPER_JOKER"));
    }
    handleReelStrike() {
        const reelDisplayData = this.model.getReelDisplayData();
        const columnIndex = reelDisplayData.getStopIndex();
        this.playSound(this.getSoundPropertiesFromId(`REEL_STRIKE_${columnIndex}`));
    }
    handleReelStrikeFreeSpin() {
        this.playSound(this.getSoundPropertiesFromId("REEL_STRIKE_FREE_SPIN"));
    }
    handleFreeSpinTween() {
        this.playSound(this.getSoundPropertiesFromId("FREE_SPIN_TWEEN"));
    }
    handleDabSuccess() {
        let ticketDab = this.model.getDabData();
        this.playSound(SoundConstants.getDab(ticketDab.getNumberOfDabs()));
    }
    handleDabComplete() {
        if (!this.model.isComplete()) {
            this.playBackground();
        }
    }
    handleSlingoSingle() {
        this.playSound(this.getSoundPropertiesFromId("SLINGO_1"));
    }
    handleSlingoDouble() {
        this.playSound(this.getSoundPropertiesFromId("SLINGO_2"));
    }
    handleSlingoTriple() {
        this.playSound(this.getSoundPropertiesFromId("SLINGO_3"));
    }
    handleSlingoQuadruple() {
        this.playSound(this.getSoundPropertiesFromId("SLINGO_4"));
    }
    handleGameSummary() {
        this.stopBackground();
        let result = this.model.getResultData();
        if (result.hasNoWin()) {
            this.playSound(this.getSoundPropertiesFromId("GAME_OVER"));
        }
        else if (result.isFullHouse()) {
            this.playSound(this.getSoundPropertiesFromId("GAME_SUMMARY_FULL_HOUSE"));
        }
        else if (result.isBigWin()) {
            this.playSound(this.getSoundPropertiesFromId("GAME_SUMMARY_BIG_WIN"));
        }
        else if (result.hasWin2x()) {
            this.playSound(this.getSoundPropertiesFromId("GAME_SUMMARY_NORMAL_WIN"));
        }
        else if (result.isSmallWin()) {
            this.playSound(this.getSoundPropertiesFromId("GAME_SUMMARY_SMALL_WIN"));
        }
        else if (result.isLowWin()) {
            this.playSound(this.getSoundPropertiesFromId("GAME_SUMMARY_LOW_WIN"));
        }
        else {
            this.playSound(this.getSoundPropertiesFromId("GAME_SUMMARY"));
        }
    }
    handleStakeSelectedIncrement() {
        this.playSound(this.getSoundPropertiesFromId("INCREASE_STAKE"));
    }
    handleStakeSelectedDecrement() {
        this.playSound(this.getSoundPropertiesFromId("DECREASE_STAKE"));
    }
    handleStakeSelectedSame() {
        this.playSound(this.getSoundPropertiesFromId("NULL_CLICK"));
    }
    handleFullHouseAnimationPhaseOne() {
        this.stopBackground();
        this.playSound(this.getSoundPropertiesFromId("FULL_HOUSE_PHASE_ONE"));
    }
    handleFullHouseAnimationPhaseTwo() {
        this.stopBackground();
        this.playSound(this.getSoundPropertiesFromId("FULL_HOUSE_PHASE_TWO"));
    }
    handleBigWinAnimationPhaseOne() {
        this.stopBackground();
        this.playSound(this.getSoundPropertiesFromId("BIG_WIN_PHASE_ONE"));
    }
    handleFreeSpinAwarded() {
        this.playSound(this.getSoundPropertiesFromId("FREE_SPIN_AWARDED"));
    }
    handleAvailableWin() {
        if (this.loaderClosed) {
            this.playSound(this.getSoundPropertiesFromId("AVAILABLE_WIN"));
        }
    }
    handleLevelUp() {
        this.playSound(SoundConstants.getLevelUp(this.model.getCurrentMatchedPatterns()));
    }
    handleNullClick() {
        this.playSound(this.getSoundPropertiesFromId("NULL_CLICK"));
    }
    handlePlaySpineSound(event) {
        const data = event.getCurrentTarget();
        this.playSound(this.getSoundPropertiesFromId(data.getAudioId()));
    }
    getSoundPropertiesFromId(id) {
        const soundName = id.split(":")[0]; //with spine events id will return name with module name after ':' which we don't want
        return this.soundManager.getRegisteredSound(soundName);
    }
}
//# sourceMappingURL=SoundController.js.map